module.exports = "/assets/d4180b2ebf33f67e0c0b442656e4dafe.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/HV.png
// module id = 2578
// module chunks = 0